import { render } from "./SnapshotIssues.vue?vue&type=template&id=258313fc"
import script from "./SnapshotIssues.vue?vue&type=script&lang=js"
export * from "./SnapshotIssues.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__